import styled from 'styled-components';

export const OauthMessage = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px;

  p {
    width: fit-content;
    padding-left: 8px;
  }
`;
